/**
 * スクロールに応じて要素の透明度を変更し、完全に透明になったら特定のクラスを付与
 * 
 * 使用方法:
 * <div class="scroll-opacity-fade" 
 *      data-fade-distance="200"
 *      data-fade-offset="0"
 *      data-fade-class="is-transparent">
 * 
 * data-fade-distance: フェードが完了するまでのスクロール距離（デフォルト: 200px）
 * data-fade-offset: フェードを開始するスクロール位置のオフセット（デフォルト: 0px）
 * data-fade-class: 完全に透明になった時に付与するクラス（デフォルト: "is-faded"）
 */

export function scrollOpacityFade() {
  const elements = document.querySelectorAll('.scroll-opacity-fade');
  
  if (!elements.length) return;
  
  // 各要素の設定を保存
  const configs = new Map();
  
  elements.forEach(element => {
    // data属性から設定を取得
    const fadeDistance = parseInt(element.dataset.fadeDistance) || 200;
    const fadeOffset = parseInt(element.dataset.fadeOffset) || 0;
    const fadeClass = element.dataset.fadeClass || 'is-faded';
    
    configs.set(element, {
      fadeDistance,
      fadeOffset,
      fadeClass,
      isTransparent: false
    });
  });
  
  // スクロールハンドラー
  const handleScroll = () => {
    const scrollY = window.scrollY;
    
    elements.forEach(element => {
      const config = configs.get(element);
      const { fadeDistance, fadeOffset, fadeClass, isTransparent } = config;
      
      // スクロール位置に基づいて透明度を計算
      const fadeStart = fadeOffset;
      const fadeEnd = fadeOffset + fadeDistance;
      
      if (scrollY <= fadeStart) {
        // フェード開始前
        element.style.opacity = '1';
        if (isTransparent) {
          element.classList.remove(fadeClass);
          config.isTransparent = false;
        }
      } else if (scrollY >= fadeEnd) {
        // フェード完了
        element.style.opacity = '0';
        if (!isTransparent) {
          element.classList.add(fadeClass);
          config.isTransparent = true;
        }
      } else {
        // フェード中
        const progress = (scrollY - fadeStart) / fadeDistance;
        const opacity = 1 - progress;
        element.style.opacity = opacity.toString();
        
        if (isTransparent) {
          element.classList.remove(fadeClass);
          config.isTransparent = false;
        }
      }
    });
  };
  
  // 初期状態を設定
  handleScroll();
  
  // スクロールイベントにリスナーを追加（パフォーマンスのためthrottleを使用）
  let ticking = false;
  const scrollListener = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  };
  
  window.addEventListener('scroll', scrollListener);
  
  // リサイズ時にも再計算
  window.addEventListener('resize', handleScroll);
  
  // クリーンアップ関数を返す（必要に応じて）
  return () => {
    window.removeEventListener('scroll', scrollListener);
    window.removeEventListener('resize', handleScroll);
  };
}